import Form from './form'
import React, { useMemo, useState } from 'react'
import { moveResourceDetailPromise } from 'api/MoveWorkout'

export default function CourseAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    moveResourceDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form mode='edit' data={data} setData={setData} {...props} />
}